module.exports = __webpack_public_path__ + "static/media/footer.45ca6f09.png";